<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Notas Fiscais APVS {{ sistema }} - {{ mes }}/{{ ano }}</h3>
        <small class="text-muted">
          Importando NF pelo consultor: <b>{{ id_consultor }}</b>
        </small>
      </div>
    </div>

    <!-- Formulario -->
    <div class="card mb-3">
      <div class="card-body">
        <div class="form-row">
          <!-- Arquivo -->
          <div class="col-md-6 mb-3">
            <label class="font-weight-bold">Arquivo PDF</label>
            <div class="custom-file">
              <input
                type="file"
                class="custom-file-input"
                id="arquivoNota"
                accept=".xml,.pdf"
                @change="selecionarArquivo"
                :disabled="!liberado"
              />
              <label class="custom-file-label" for="arquivoNota">
                {{ arquivo ? arquivo.name : "Selecione o arquivo..." }}
              </label>
            </div>
          </div>

          <!-- Valor -->
          <div class="col-md-6 mb-3">
            <label class="font-weight-bold">Valor</label>
            <input
              type="text"
              class="form-control"
              v-model="valorNota"
              @input="formatarValor"
              placeholder="R$ 0,00"
              :disabled="!liberado"
            />
          </div>
        </div>

        <div class="form-row align-items-end">
          <!-- CPF/CNPJ -->
          <div class="col-md-4 mb-3">
            <label class="font-weight-bold">
              CNPJ do Prestador (Nota de Servico Emitida)
            </label>
            <input
              type="text"
              class="form-control"
              v-model="cpfCnpjPrestador"
              @input="aplicarMascara"
              @blur="buscarPrestador"
              placeholder="Digite o CNPJ"
              :disabled="!liberado"
            />
          </div>

          <!-- Nome Prestador -->
          <div class="col-md-5 mb-3">
            <label class="font-weight-bold">Nome do Prestador</label>
            <input type="text" class="form-control" v-model="prestador" readonly />
          </div>

          <!-- Botao -->
          <div class="col-md-3 mb-3">
            <button
              class="btn btn-primary btn-block btn-azul"
              @click="enviarNota"
              :disabled="enviandoNota || !liberado"
            >
              <span v-if="enviandoNota">
                <i class="fa fa-spinner fa-spin"></i> Enviando...
              </span>
              <span v-else>
                Enviar Nota
              </span>
            </button>
          </div>
        </div>

        <div v-if="!liberado" class="alert alert-danger mb-0">
          Este consultor esta <b>BLOQUEADO</b> para importacao de NF por Regional.
        </div>
      </div>
      </div>

    <!-- Lista -->
    <div class="card">
      <div class="card-body min-vh-25">
        <div v-if="errored" class="text-center">Erro ao carregar notas.</div>
        <vcl-list v-else-if="loading"></vcl-list>
        <div v-else-if="notas.length === 0" class="text-center">Nenhuma nota encontrada.</div>

        <div v-else>
          <b-table stacked="md"
            :items="notas"
            :fields="fields"
            responsive
            head-variant="light"
            :tbody-tr-class="rowClass"
          >
            <template #cell(nf_date_added)="row">
              {{ new Date(row.item.nf_date_added).toLocaleString("pt-BR") }}
            </template>

            <template #cell(nf_valor)="row">
              {{ formatarMoeda(parseFloat(row.item.nf_valor)) }}
            </template>

            <template #cell(nf_data_pagamento)="row">
              {{
                row.item.nf_data_pagamento
                  ? new Date(row.item.nf_data_pagamento + "T00:00:00").toLocaleDateString("pt-BR", {
                      timeZone: "America/Sao_Paulo",
                    })
                  : ""
              }}
            </template>

            <template #cell(nf_status)="row">
              <span v-if="row.item.nf_status === 'pending'" class="badge badge-status status-pendente">PENDENTE</span>
              <span v-else-if="row.item.nf_status === 'approved'" class="badge badge-status status-aprovado">APROVADO</span>
              <span v-else-if="row.item.nf_status === 'reproved'" class="badge badge-status status-reprovado">REPROVADO</span>
              <span v-else-if="row.item.nf_status === 'returned'" class="badge badge-status status-devolvido">DEVOLVIDA</span>
            </template>

            <!-- Botes de ao -->
            <template #cell(actions)="row">
              <button
                class="btn btn-primary btn-sm btn-azul mr-2"
                @click="$router.push({ name: 'VisualizarNotaBrasil', params: { idNota: row.item.nf_id } })"
              >
                Visualizar
              </button>

              <button
                v-if="row.item.nf_status === 'pending' && liberado"
                class="btn btn-sm btn-danger"
                @click="abrirConfirmacao(row.item)"
              >
                Excluir
              </button>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- Popup de confirmao -->
    <div v-if="showConfirm" class="confirm-overlay">
      <div class="confirm-box">
        <h5>Excluir Nota Fiscal</h5>
        <p>Tem certeza que deseja excluir esta nota fiscal? Essa ao no poder ser desfeita.</p>

        <div class="text-right mt-3">
          <button class="btn btn-secondary mr-2" @click="showConfirm = false">Cancelar</button>
          <button class="btn btn-danger" @click="confirmarExclusao">Excluir</button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";

export default {
  components: { Layout, VclList },
  data() {
    return {
      liberado: false,

      podeEnviarNF: true,
      loading: true,
      errored: false,
      enviandoNota: false,
      notas: [],

      sistema: this.$route.params.sistema,
      mes: this.$route.params.mes,
      ano: this.$route.params.ano,
      line_id: this.$route.params.line_id,
      id_consultor: this.$route.params.id_consultor,

      arquivo: null,
      valorNota: "",
      cpfCnpjPrestador: "",
      prestador: "",

      showConfirm: false,
      notaParaExcluir: null,

      fields: [
        { key: "nf_date_added", label: "Data Importao", sortable: true },
        { key: "nf_valor", label: "Valor", sortable: true },
        { key: "nf_lote", label: "Lote" },
        { key: "nf_data_pagamento", label: "Previso Pagamento" },
        { key: "nf_status", label: "Status" },
        { key: "actions", label: "Aes" },
      ],
    };
  },
  methods: {
    rowClass(item) {
      if (!item) return "";
      return item.nf_status === "pending" ? "row-pendente" : "";
    },

    //  valida consultor antes de liberar
    async validarConsultor() {
      this.liberado = false;
      this.$toast.error(
        "A importacao de NF de consultores pela regional nao esta mais disponivel."
      );
      this.$router.back();
    },

    getNotas() {
      this.loading = true;

      api.get(`notasfiscais/listar/${this.sistema}/${this.line_id}`)
        .then((res) => {
          if (res.data.status === "success") this.notas = res.data.notas;
        })
        .catch(() => (this.errored = true))
        .finally(() => (this.loading = false));
    },

    selecionarArquivo(e) {
      this.arquivo = e.target.files[0];
    },

    async obterIdConferencia(pdfUrl, valorFloat) {
      if (!pdfUrl) return "";
      try {
        const agora = new Date();
        const response = await api.post(`notasfiscais/analisar/${this.sistema}`, {
          pdf_url: pdfUrl,
          tipo: this.sistema,
          competencia: `${String(agora.getMonth() + 1).padStart(2, "0")}/${agora.getFullYear()}`,
          cnpj_prestador: this.cpfCnpjPrestador,
          valor_esperado: Number(valorFloat).toFixed(2),
        }, {
          timeout: 10000,
        });
        const data = response?.data;
        return data?.id ? String(data.id) : "";
      } catch (_) {
        return "";
      }
    },
    aplicarMascara() {
      let v = this.cpfCnpjPrestador.replace(/\D/g, "");
      if (v.length <= 11) {
        v = v.replace(/(\d{3})(\d)/, "$1.$2");
        v = v.replace(/(\d{3})(\d)/, "$1.$2");
        v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      } else {
        v = v.replace(/^(\d{2})(\d)/, "$1.$2");
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
        v = v.replace(/(\d{4})(\d)/, "$1-$2");
      }
      this.cpfCnpjPrestador = v;
    },

    async buscarPrestador() {
      const documento = (this.cpfCnpjPrestador || "").replace(/\D/g, "");
      if (!documento) return;

        try {
        const { data } = await api.get("prestador/buscar/" + documento, {
            headers: { "x-auth-token": localStorage.token }
        });

        if (data?.status === "success") {
            this.prestador = data.nome || "";
            this.$toast.success("Prestador validado e vinculado  sua Regional.");
        } else {
            this.prestador = "";
            this.$toast.error(data?.message || "Erro ao validar prestador.");
        }
        } catch (err) {
        this.$toast.error("Erro ao buscar prestador. Verifique sua conexo.");
        }
    },

    formatarValor() {
      let v = this.valorNota.replace(/\D/g, "");
      v = (v / 100).toFixed(2) + "";
      v = v.replace(".", ",");
      v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.valorNota = `R$ ${v}`;
    },

    formatarMoeda(valor) {
      if (!valor || isNaN(valor)) return "R$ 0,00";
      return valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },

    async enviarNota() {
      if (!this.liberado) {
        this.$toast.error("Consultor bloqueado.");
        return;
      }

      if (!this.podeEnviarNF) {
        this.$toast.error("O perodo j foi fechado, no  possvel enviar notas neste ms.");
        return;
      }

      if (this.enviandoNota) return;
      if (!this.arquivo) return this.$toast.warning("Selecione um arquivo!");
      if (!this.valorNota || !this.prestador) return this.$toast.warning("Informe valor e prestador!");

      this.enviandoNota = true;
      const sistema = this.sistema;

      try {
        const valorFloat = this.valorNota.replace(/\D/g, "") / 100;

        const validaRes = await api.post(`notasfiscais/validarvalor/${sistema}`, {
          nf_idline: this.line_id,
          nf_valor: valorFloat,
        });

        if (validaRes.data?.status !== "success") {
          this.$toast.error(validaRes.data?.message || "Validao reprovada.");
          return;
        }

        const formData = new FormData();
        formData.append("file", this.arquivo);
        formData.append("nf_idline", this.line_id);
        formData.append("nf_valor", valorFloat);
        formData.append("nf_document_prestador", this.cpfCnpjPrestador);

        const uploadRes = await api.post(`notasfiscais/uploadarquivo/${sistema}`, formData, {
        });

        if (uploadRes.data?.status !== "success") {
          this.$toast.error(uploadRes.data?.message || "Falha no upload.");
          return;
        }

        const pdfUrl = uploadRes.data?.pdf_url || uploadRes.data?.arquivo || "";
        const idConferencia = await this.obterIdConferencia(pdfUrl, valorFloat);

        const nfId = uploadRes.data.nf_id;

        const updateRes = await api.post(`notasfiscais/updatedados/${sistema}`, {
          nf_id: nfId,
          nf_idline: this.line_id,
          nf_valor: valorFloat,
          nf_nome_prestador: this.prestador,
          nf_document_prestador: this.cpfCnpjPrestador,
          nf_id_conferencia: idConferencia,
        });

        if (updateRes.data?.status === "success") {
          this.$toast.success("Nota salva com sucesso!");

          this.arquivo = null;
          this.valorNota = "";
          this.cpfCnpjPrestador = "";
          this.prestador = "";

          this.getNotas();
        } else {
          this.$toast.error(updateRes.data?.message || "Falha ao salvar dados.");
        }
      } finally {
        this.enviandoNota = false;
      }
    },
    abrirConfirmacao(nota) {
      this.notaParaExcluir = nota;
      this.showConfirm = true;
    },

    async confirmarExclusao() {
      if (!this.notaParaExcluir) return;
      const idNota = this.notaParaExcluir.nf_id;

      try {
        const res = await api.post(`notasfiscais/deletar/brasil/${idNota}`);

        if (res.data.status === "success") {
          this.$toast.success("Nota excluda com sucesso!");
          this.showConfirm = false;
          this.notaParaExcluir = null;

          setTimeout(() => {
            this.getNotas();
            window.location.reload();
          }, 1500);
        } else {
          this.$toast.error(res.data.message || "Erro ao excluir nota.");
        }
      } catch (e) {
        this.$toast.error("Falha ao excluir a nota fiscal.");
      } finally {
        this.showConfirm = false;
        this.notaParaExcluir = null;
      }
    },
  },

  async mounted() {
    await this.validarConsultor();
    this.getNotas();
  },
};
</script>

<style scoped>
/* Contraste: texto branco sobre os fundos antigos dava 2,63:1 (pendente)
   e 4,39:1 (aprovado) — abaixo do AA de 4,5:1 exigido para texto pequeno,
   justamente no sinal primario do fluxo de nota fiscal. Trocado pelo padrao
   "soft" (fundo claro + texto escuro da mesma familia), todos acima de 7:1. */
.badge-status {
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
}
.status-pendente {
  background-color: var(--st-status-pending-bg) !important;
  border-color: var(--st-status-pending-border);
  color: var(--st-status-pending-text) !important;
}
.status-aprovado {
  background-color: var(--st-status-approved-bg) !important;
  border-color: var(--st-status-approved-border);
  color: var(--st-status-approved-text) !important;
}
.status-reprovado {
  background-color: var(--st-status-rejected-bg) !important;
  border-color: var(--st-status-rejected-border);
  color: var(--st-status-rejected-text) !important;
}
.status-devolvido {
  background-color: var(--st-status-returned-bg) !important;
  border-color: var(--st-status-returned-border);
  color: var(--st-status-returned-text) !important;
}

/* Linha pendente: destaque suave em vez do rosa saturado #ffcccc, que
   destoava de toda a paleta e ainda competia com o badge de status. */
.row-pendente {
  background-color: var(--st-status-pending-bg) !important;
  color: var(--st-text) !important;
}

.btn-azul {
  background-color: var(--st-brand) !important;
  border: none;
}

/* Popup de confirmao */
.confirm-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.confirm-box {
  background: var(--st-surface);
  padding: 25px 20px;
  border-radius: var(--st-radius-lg);
  max-width: 400px;
  width: 90%;
  text-align: left;
  box-shadow: var(--st-shadow-lg);
  color: var(--st-text);
}
.confirm-box h5 {
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
